export function nl2br(str) {
  if (!str) return str;
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
}

export function autolink(str) {
  if (!str) return str;
  // http://, https://, ftp://
  const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
  // www. sans http:// or https://
  const pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  // Email addresses
  const emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;

  return str
    .replace(urlPattern, '<a href="$&">$&</a>')
    .replace(pseudoUrlPattern, '$1<a href="http://$2">$2</a>')
    .replace(emailAddressPattern, '<a href="mailto:$&">$&</a>');
}

export function serialize(obj) {
  const encodeParam = (key, val) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;

  let str = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (Array.isArray(obj[key])) {
        str = str.concat(obj[key].map(val => encodeParam(key, val)));
      } else {
        str.push(encodeParam(key, obj[key]));
      }
    }
  }
  return str.join('&');
}



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/models/TextUtils.es6
 **/